import React from "react";
import { useDialogA11y } from "../Backdrop/Backdrop";
import { AppAlert, subscribeAlerts } from "../../utils/alert";
import "./AlertDialog.scss";

// Renders alerts raised with showAlert() one at a time, centred over the page,
// until the user presses OK (or Escape). role="alertdialog" so screen readers
// read the message as soon as it opens; focus is trapped and then restored.
export const AlertHost: React.FC = () => {
  const [queue, setQueue] = React.useState<AppAlert[]>([]);
  const current = queue[0];

  React.useEffect(
    () => subscribeAlerts((alert) => setQueue((q) => [...q, alert])),
    []
  );

  const dismiss = React.useCallback(() => {
    current?.onClose?.();
    setQueue((q) => q.slice(1));
  }, [current]);

  const dialogRef = useDialogA11y(!!current, dismiss);

  if (!current) return null;

  return (
    <div className="appAlertOverlay">
      <div
        ref={dialogRef}
        className="appAlert"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="app-alert-title"
        aria-describedby="app-alert-message"
      >
        <span className="appAlertIcon" aria-hidden="true">!</span>
        <h2 className="appAlertTitle" id="app-alert-title">
          {current.title || "Please note"}
        </h2>
        <p className="appAlertMessage" id="app-alert-message">
          {current.message}
        </p>
        <button type="button" className="appAlertBtn" onClick={dismiss}>
          {current.buttonText || "OK"}
        </button>
      </div>
    </div>
  );
};

export default AlertHost;
